import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CardTitle = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const ThermometerContainer = styled(Box)`
  flex-direction: row;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const CoresBox = styled(Stack)`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
`;

export const ChartBox = styled(Stack)`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  gap: 2;
`;

export const ValueBox = styled(Stack)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
